<template>
  <div class="order-search">
    <div class="search-wrap">
        <div class="filter-item">
          <div class="filter-label">创建时间</div>
          <div class="filter-content">
            <el-date-picker
              v-model="createTime"
              value-format="timestamp"
              type="daterange"
              align="right"
              unlink-panels
              @change="filterHandler"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-label">创建人</div>
          <div class="filter-content">
            <el-cascader
              :options="optionsService"
              v-model="filterParams.authorIds"
              :props="propsService"
              collapse-tags
			  @change="filterHandler"
              clearable></el-cascader>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-label">处理人</div>
          <div class="filter-content">
            <el-cascader
              :options="optionsService"
              :props="propsService"
              v-model="filterParams.assigneeIds"
              collapse-tags
			  @change="filterHandler"
              clearable></el-cascader>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-label">工单分类</div>
          <div class="filter-content">
            <el-cascader
              :options="optionRules"
              v-model="filterParams.categoryIds"
              :props="propsRules"
              collapse-tags
			  @change="filterHandler"
              clearable></el-cascader>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-label">工单标题</div>
          <div class="filter-content">
            <el-input v-model="filterParams.ticketTitle" placeholder="工单标题" clearable @blur="filterHandler" @keyup.enter.native="filterHandler"></el-input>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-label">优先级</div>
          <div class="filter-content">
            <el-cascader
              :options="optionsPriority"
              v-model="filterParams.priority"
              :props="propsPriority"
              collapse-tags
			  @change="filterHandler"
              clearable></el-cascader>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-label">工单内容</div>
          <div class="filter-content">
            <el-input v-model="filterParams.ticketContent" placeholder="工单内容" clearable @blur="filterHandler" @keyup.enter.native="filterHandler"></el-input>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-label">解决时间</div>
          <div class="filter-content">
            <el-date-picker
              v-model="resolvedTime"
              value-format="timestamp"
              type="daterange"
              align="right"
              unlink-panels
              @change="filterHandler"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
		<div class="wl-btn" @click="filterHandler">搜索</div>
      </div>
      
    </div>
  </div>
</template>

<script>
    export default {
        name: "order-search",
		props:['orderStatus'],
        data() {
            let currentDateTimestamp = new Date(new Date().toLocaleDateString()).getTime() // 系统当天0点0时0分
            return {
                dialogVisible: false,
                createTime: [],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }],
					disabledDate(time) {
					  return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
					}
                },
                optionsService: [],
                propsService: {
                    multiple: true,
                    label: 'csName',
                    value: 'csId',
                    emitPath: false
                },
                optionRules: [],
                propsRules: {
                    multiple: true,
                    label: 'categoryName',
                    value: 'id',
                    children: 'subTicketCategory',
                    emitPath: false
                },
                propsStatus: {
                    multiple: true,
                    emitPath: false
                },
                optionsPriority: [{
                    label: '低',
                    value: '0'
                }, {
                    label: '中',
                    value: '1'
                }, {
                    label: '高',
                    value: '2'
                }, {
                    label: '紧急',
                    value: '3'
                }],
                propsPriority: {
                    multiple: true,
                    emitPath: false
                },
                resolvedTime: [],
                filterParams: {
                    startCreatTime: '', // 创建时间开始时间
                    endCreatTime: '', // 创建时间结束时间
                    authorIds: [], // 创建人
                    assigneeIds: [], // 处理人,指派客服
                    categoryIds: [], // 工单分类
                    status: [], // 工单状态
                    ticketTitle: '', // 工单号,标题
                    priority: [], // 优先级 0-低，1-中，2-高，3-紧急
                    ticketContent: '', // 工单内容
                    startResolvedTime: '', // 解决时间开始时间
                    endResolvedTime: '', // 解决时间结束时间
                    order: 'desc', // 排序，正序还是倒序，asc或者desc
                    orderField: 'create_time', // 排序的字段，priority优先级，create_time时间
                    pageSize: 10, // 每页数量 默认20
                    pageNum: 1, // 页数 默认1
                },
                customName: '',
                editItem: null,
            }
        },
        created() {
            this.getAllService()
            this.getSortData()
        },
        mounted() {
            this.filterParams.status = this.orderStatus
        },
		watch:{
			// 监听父页面status变化
			orderStatus:function(){
				 this.filterParams.status = this.orderStatus
			}
		},
        methods: {
            // 获取所有客服
            getAllService() {
                this.$http.getAllServiceAPI().then(res => {
                    if (res.status == 1) {
                        this.optionsService = res.data.csList
                    }
                })
            },
            getSortData() {
                 this.$http.getWorkorderSortAPI().then(res => {
                    if (res.status == 1) {
                        this.optionRules = this.recursionFunction(res.data.categoryList)
                    }
                })
            },
            recursionFunction(array) {
                if (!Array.isArray(array)) {
                    array = []
                }
                let categoryList = []
                array.map(item => {
                    let categoryItem = {}
                    if (item.isFolder == 0 || item.subTicketCategory.length > 0) {
                        categoryItem.categoryName = item.categoryName
                        categoryItem.id = item.id
                        if (item.subTicketCategory.length > 0) {
                            categoryItem.subTicketCategory = this.recursionFunction(item.subTicketCategory)
                        }
                        categoryList.push(categoryItem)
                    }
                })
                return categoryList
            },
            // 筛选搜索提交
            filterHandler() {
				if(this.createTime){
					this.filterParams.startCreatTime = this.createTime[0] / 1000
					let endTime = this.createTime[1] / 1000
					this.filterParams.endCreatTime = endTime + 24 * 60 * 60 - 1
				}else{
					this.filterParams.startCreatTime = ''
					this.filterParams.endCreatTime = ''
				}
                if(this.resolvedTime){
                	this.filterParams.startResolvedTime = this.resolvedTime[0] / 1000
                	let endTime1 = this.resolvedTime[1] / 1000
                	this.filterParams.endResolvedTime = endTime1 + 24 * 60 * 60 - 1
                }else{
                	this.filterParams.startResolvedTime = ''
                	this.filterParams.endResolvedTime = ''
                }
				eventBus.$emit('searchOrder',  this.filterParams)
            },
        }
    }
</script>

<style lang="scss">
  .order-search {
    height: 100%;
    display: flex;

    .search-wrap {
		display: flex;
		flex-wrap: wrap;
		.filter-item{
			display: flex;
			align-items: center;
			margin-right: 10px;
			margin-bottom: 15px;
			// width: 240px;
			.filter-label{
				margin-right: 10px;
			}
			.el-cascader,.el-date-editor--daterange.el-input__inner,.el-input__inner{
				width: 240px;
			}
		}
    }

  }
</style>
